import { render, staticRenderFns } from "./CreatePurchaseOrder.vue?vue&type=template&id=e0777ccc&"
import script from "./CreatePurchaseOrder.vue?vue&type=script&lang=ts&"
export * from "./CreatePurchaseOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0777ccc')) {
      api.createRecord('e0777ccc', component.options)
    } else {
      api.reload('e0777ccc', component.options)
    }
    module.hot.accept("./CreatePurchaseOrder.vue?vue&type=template&id=e0777ccc&", function () {
      api.rerender('e0777ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/CreatePurchaseOrder.vue"
export default component.exports